import DateFormat from './DateFormat';
import slugify from '../slugify';

export default sanityNodes => {
  return sanityNodes.nodes.map(show => {
    const date = new Date(Date.parse(show.date));

    const anchor = `${show.location.address.replace(/,/g, '').replace(/-/g, '').replace(/\\s/g, '-')}-${show.date}`;
    return {
      ...show,
      date: date,
      showAnchor: anchor,
      ordinalDate: getOrdinalDate(date),
      month: date.toLocaleString('default', { month: 'long' }),
      year: date.getFullYear(),
      dayNumeric: date.toLocaleString('default', { day: 'numeric' }),
      dayText: date.toLocaleString('en-GB', { weekday: 'long' }),
      id: encodeURI(anchor),
      formattedDate: DateFormat(date),
      compereSlug: show?.compere?.name ? slugify(show?.compere?.name) : null,
    };
  });
};

const getOrdinalDate = date => {
  const plural = new Intl.PluralRules('en-GB', { type: 'ordinal' });
  const ordinals = {
    one: 'st',
    two: 'nd',
    few: 'rd',
    many: 'th',
    zero: 'th',
    other: 'th',
  };
  return ordinals[plural.select(date.toLocaleString('default', { day: 'numeric' }))];
};
